import React, { Component } from 'react';
import { arrayOf, bool, func, shape, string } from 'prop-types';
import { Tooltip } from 'ps-design';
import Cell from 'ps-components/Table/Cell/Cell';
import CheckboxInput from 'ps-components/Input/CheckboxInput';
import Row from 'ps-components/Table/Row/Row';
import Dropdown from 'ps-components/Dropdown/Dropdown';
import TruncatedString from 'ps-components/TruncatedString/TruncatedString';
import SurveyJobTitle from '../../SurveyJobMatches/SurveyJobTitle/SurveyJobTitle';

import './ListItem.scss';

const OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

class ListItem extends Component {
  static propTypes = {
    datum: shape({
      id: string,
      orgJob: shape({
        id: string
      }),
      surveyJob: shape({
        code: string,
        description: string,
        id: string,
        survey: shape({
          code: string,
          id: string,
          name: string
        }),
        title: string
      })
    }),
    onClick: func,
    selectedItems: arrayOf(string),
    showSurveyJobDescription: bool
  };

  getSurveyJobTitleDisplay = () => {
    const { datum, showSurveyJobDescription } = this.props;

    return (
      <SurveyJobTitle
        description={datum.surveyJob.description}
        title={datum.surveyJob.title}
        showJobDescription={showSurveyJobDescription}
      />
    );
  };

  generateTooltip = () => {
    const { datum } = this.props;

    return (
      <Tooltip
        display="underline"
        hoverText={datum.surveyJob.description}
        id={datum.surveyJob.title}
        position="bottom"
        tooltipText={datum.surveyJob.title}
      />
    );
  };

  handleClick = () => {
    const { datum, onClick } = this.props;
    onClick(datum.surveyJob.code, datum.surveyJob.survey.code, datum.id);
  };

  renderPriorityCell() {
    const disabled = true;

    return (
      <Dropdown
        className={
          disabled ? 'pxl-btn pxl-btn-sm disabled priority__cell-select' : 'pxl-btn pxl-btn-sm priority__cell-select'
        }
        disabled={disabled}
        dropdownItems={OPTIONS}
        dropdownClass="priority__cell-dropdown-items"
        itemOnClick={() => {
          console.log('changed priority');
        }}
        text={1}
      />
    );
  }

  renderPriorityOptions() {
    return OPTIONS.map(option => <option key={option}>{option}</option>);
  }

  render() {
    const { datum, selectedItems, showSurveyJobDescription } = this.props;
    const checked = selectedItems.some(val => val.matchId === datum.id || val.matchId === datum.surveyJob.id);

    return (
      <Row className="data__row">
        <Cell className="data__cell-checkbox">
          <CheckboxInput checked={checked} className="data__cell-checkbox-input" onClick={this.handleClick} />
        </Cell>
        <Cell className="data__cell-data pxl-text-xsmall">
          {datum.isMeritMatch && <div className="data__cell-datum merit-match-indicator">Market Pricing Match</div>}
          <div className="data__cell-datum pxl-text-muted">{datum.surveyJob.code}</div>
          <div className="data__cell-datum datum__bold pxl-text-small">{this.getSurveyJobTitleDisplay()}</div>
          {showSurveyJobDescription && <TruncatedString maxChar={150}>{datum.surveyJob.description}</TruncatedString>}
        </Cell>
        <Cell className="data__cell-data">
          <div className="data__cell-datum pxl-text-muted pxl-text-xsmall">{datum.surveyJob.survey.code}</div>
          <div className="data__cell-datum pxl-text-xsmall">{datum.surveyJob.survey.name}</div>
        </Cell>
        {/*<Cell className="data__cell-data priority__cell">{this.renderPriorityCell()}</Cell>*/}
        <Cell className="data__cell-data">
          <CheckboxInput
            checked={true}
            className="data__cell-checkbox-input"
            disabled={true}
            onClick={() => {
              console.log('participate');
            }}
          />
        </Cell>
      </Row>
    );
  }
}

export default ListItem;
